import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getUsersList } from 'api/Admin/Users';

export const useAdminUsersList = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['getAdminUsersList', ...dependencies], () => getUsersList(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};
